"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = '6.7.4';



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/version.js
// module id = 1461
// module chunks = 1